module.exports = __webpack_public_path__ + "static/media/thank_you_hand_white_bg.4042732a.svg";